import request from '@/utils/request'

// 成绩查询
export const searchUserScore = (params) => {
    return request({
        url: '/tezhao/compet/user/searchUserScoreById',
        method: 'get',
        params
    })
}

export const listCompetInfo = (params) => {
    return request({
        url: '/tezhao/compet/manage/listCompetInfo',
        method: 'get',
        params
    })
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return request({
        url: '/system/dict-data/list',
        method: 'get',
        params: { dictType }
    })
}

//查询教师竞赛证书
export const listTeacher = (params) => {
    return request({
        url: '/tezhao/compet/teacher/listTeacher',
        method: 'get',
        params
    })
}

//年级
export function getGradeList(params) {
    return request({ url: '/tezhao/compet/grade/treelist', method: 'get', params })
}


// WEBPACK FOOTER //
// ./src/api/home.js